/**
 * Centralized constants for SEO / Open Graph / JSON-LD.
 * Edit these in one place; all per-route `<Seo />` usages inherit sensible defaults.
 */

export const SITE_NAME = '05 Creation';

export const SITE_URL = (import.meta.env.VITE_PUBLIC_APP_URL ?? 'https://05creation.com').replace(
	/\/$/,
	''
);

export const DEFAULT_TITLE = '05 Creation — Custom product manufacturing for ambitious brands';

export const DEFAULT_DESCRIPTION =
	'Design, quote, and produce custom branded products at scale. AI-assisted design, hand-picked supplier network, built-in quoting and project management — from idea to delivery.';

export const DEFAULT_OG_IMAGE = '/og-image-v3.jpg';

export const TWITTER_HANDLE = '@05creation';

/** Our social profiles: linked from the site's footer and listed as `sameAs` in the Organization JSON-LD. */
export const SOCIAL = {
	instagram: 'https://www.instagram.com/05creationcom/',
	linkedin: 'https://www.linkedin.com/company/05creation/',
	tiktok: 'https://www.tiktok.com/@05creation',
} as const;

export const SOCIAL_LINKS = Object.values(SOCIAL);

export const absoluteUrl = (path: string): string => {
	if (/^https?:\/\//.test(path)) return path;
	return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
